/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Meta_Campaigns_DescriptionInputs */



/**
* | output |
* | --- |
* | "Giveaways with entry rules, bonus entries and role or XP prizes, designed in the message builder and measured on your timeline." |
*
* @param {Meta_Campaigns_DescriptionInputs} inputs
* @param {{ locale?: "en" | "ru" }} options
* @returns {LocalizedString}
*/
export const meta_campaigns_description = /** @type {((inputs?: Meta_Campaigns_DescriptionInputs, options?: { locale?: "en" | "ru" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Meta_Campaigns_DescriptionInputs, { locale?: "en" | "ru" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ru") return /** @type {LocalizedString} */ ("Розыгрыши с условиями участия, бонусными шансами и призами в виде роли или XP, оформленные в конструкторе сообщений и измеренные на вашей временной шкале.")
	return /** @type {LocalizedString} */ ("Giveaways with entry rules, bonus entries and role or XP prizes, designed in the message builder and measured on your timeline.")
});